import { render, staticRenderFns } from "./Conjuntos.vue?vue&type=template&id=96124b7c&"
import script from "./Conjuntos.vue?vue&type=script&lang=js&"
export * from "./Conjuntos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports